import React, { memo } from 'react';
import { ButtonSize, ButtonVariant } from "../button";
import { IconCross } from "../icons";
import { Row } from "../layout";
import { ProgressBar, Status } from "../progress-bar";
import { IconButton } from "./helperComponents";
import { jsx as ___EmotionJSX } from "@emotion/core";
var FileDetailsProgress = /*#__PURE__*/memo(function (_ref) {
  var cancelUploadButtonTitle = _ref.cancelUploadButtonTitle,
      handleRemoveFile = _ref.handleRemoveFile,
      uploadProgress = _ref.uploadProgress,
      ariaLive = _ref['aria-live'],
      fileName = _ref.fileName,
      getAriaLabel = _ref.getAriaLabel,
      getProgressSummary = _ref.getProgressSummary;
  var ariaLabel = getAriaLabel(fileName);
  var progressSummary = getProgressSummary(uploadProgress);
  return ___EmotionJSX(Row, {
    gridGap: "S100"
  }, ___EmotionJSX(ProgressBar, {
    progress: uploadProgress / 100,
    status: Status.Positive,
    "aria-label": ariaLabel,
    "aria-live": ariaLive,
    progressSummary: progressSummary
  }), ___EmotionJSX(IconButton, {
    baseColor: "neutral",
    icon: ___EmotionJSX(IconCross, {
      title: cancelUploadButtonTitle
    }),
    onClick: handleRemoveFile,
    size: ButtonSize.Small,
    variant: ButtonVariant.Tertiary
  }));
});
FileDetailsProgress.displayName = '';
export default FileDetailsProgress;